<template>
  <div class="credit-wrap">
    <div class="credit-add" v-if="cardList.length<3">
      <div @click="handleAddCredit">
        <i class="fps-icon-add fps-icon"></i>
        <span>新增信用卡</span>
      </div>
    </div>
    <div class="gmail-wrap" v-if="cardList.length&&!switchValue">
      <div class="gmail-con" v-for="(card,index) in cardList" :key="card.tokenTerm">
        <div>
          <el-radio v-model="radio" :label="card.tokenTerm" @change="handleRadio"></el-radio>
          <img v-if="cardLogList[index]==='reVisa'" src="~@/assets/imgs/icon-visa.png" alt="">
          <img v-else-if="cardLogList[index]==='reMc'" src="~@/assets/imgs/icon-mastercard.png" alt="">
          <img v-else src="~@/assets/imgs/icon-jcb.png" alt="">
          <h4>{{card.cardInfo | formDecrypt}}</h4>
        </div>
        <span @click="handleDelete(card)">刪除</span>
      </div>
    </div>
    <div class="gmail-wrap" v-if="cardList.length&&switchValue">
      <div class="gmail-con">
        <div>
          <el-radio v-model="radio" :label="cardList[0].tokenTerm" @change="handleRadio"></el-radio>
          <img v-if="cardLogList[0]==='reVisa'" src="~@/assets/imgs/icon-visa.png" alt="">
          <img v-else-if="cardLogList[0]==='reMc'" src="~@/assets/imgs/icon-mastercard.png" alt="">
          <img v-else src="~@/assets/imgs/icon-jcb.png" alt="">
          <h4>{{cardList[0].cardInfo | formDecrypt}}</h4>
        </div>
        <span @click="handleDelete(cardList[0])">刪除</span>
      </div>
    </div>
    <div v-show="cardList.length&&cardList.length>1&&!switchValue" class="switch-add">
      <div @click="handleSwitch">
        <span>收起信用卡</span>
        <i class="fps-icon-arrow-up fps-icon"></i>
      </div>
    </div>
    <div v-show="cardList.length&&cardList.length>1&&switchValue" class="switch-add">
      <div @click="switchValue=!switchValue">
        <span>展開信用卡</span>
        <i class="fps-icon-arrow-down fps-icon"></i>
      </div>
    </div>
    <el-dialog
      title="新增信用卡"
      width="375px"
      class="add-credit-dialog-wrap"
      :visible="addCreditVisible"
      @close='addCreditVisible=false'
      append-to-body
    >
      <el-form :model="creditForm" :rules="rules" ref="creditForm" label-width="0">
        <div>
          <div class="card-con">
            <h4>信用卡號</h4>
            <div class="img-con">
              <img src="~@/assets/imgs/icon-visa.png" alt="">
              <img src="~@/assets/imgs/icon-mastercard.png" alt="">
              <img src="~@/assets/imgs/icon-jcb.png" alt="">
            </div>
          </div>
          <div class="form-item-con">
            <el-form-item prop="ccnum">
              <el-input v-model="creditForm.ccnum" placeholder="0000 0000 0000"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-button type="primary" @click="submitForm('creditForm')">添加信用卡</el-button>
          <!-- <el-button @click="resetForm('creditForm')">重置</el-button> -->
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Encrypt, Decrypt } from '@/utils/crypto-aes'
import { getCardTypeReg } from '@/utils/pay'
export default {
  name: 'creditCard',
  created() {
    this.getCardList()
  },
  data() {
    const valiCcnum = (rule, value ,callback) => {
      if(!value) callback(new Error('請輸入信用卡卡號'))
      const re = getCardTypeReg(value);
      if (!re) {
        callback(new Error('請輸入正確的卡號'))
      }else {
        callback()
      }
    }
    return {
      cardList: [],
      cardLogList: [],
      creditNum: '7465123456781532',
      switchValue: true,
      radio: 1,
      addCreditVisible: false,
      creditForm: {
        ccnum: '',
        backnum: '',
        email: ''
      },
      rules: {
        ccnum: [
          { validator: valiCcnum, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 收起
    handleSwitch() {
      const currentList = []
      const oldList = []
      this.cardList.forEach((value) => {
        if (value.tokenTerm === this.radio) {
        currentList.push(value)
        }else {
          oldList.push(value)
        }
      })
      this.cardList = [...currentList, ...oldList]
      this.switchValue=!this.switchValue
    },
    handleRadio(value) {
      this.$emit('handleRadio', value)
    },
    handleDelete(cardInfo) {
      this.$confirm({
        content: '確認刪除信用卡',
        confirmButtonText: '確定',
        cancelButtonText: '再想想',
      }).then(() => {
        this.$http.post('/payment/deleteQuickPay', {
          cardInfo: cardInfo.cardInfo,
          tokenTerm: cardInfo.tokenTerm
        }).then(({msg, success}) => {
          if(success) {
            this.getCardList()
          }else {
            this.$message.error(msg)
          }
        })
      }).catch(() => {})
    },
    getCardList() {
      this.$http.get('/payment/getQuickPayInfos').then(({data}) => {
        if (data) {
          let cardLogList = []
          this.cardList = [...data]
          data.forEach((value, index) => {
            if(index===0) {
              this.handleRadio(value.tokenTerm)
              this.radio= value.tokenTerm
            }
            cardLogList.push(getCardTypeReg(Decrypt(value.cardInfo)))
          })
          this.cardLogList = [...cardLogList]
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newCcnum = Encrypt(this.creditForm.ccnum)
          this.$http.post('/payment/bindQuickPay', {
            cardInfo: newCcnum
          }).then(({msg, success}) => {
            if(success) {
              this.getCardList()
            }else {
              this.$message.error(msg)
            }
          })
          this.addCreditVisible = false
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName] && this.$refs[formName].resetFields) {
        this.$refs[formName].resetFields();
      }
    },
    handleAddCredit() {
      this.resetForm('creditForm')
      this.addCreditVisible = true
    }
  },
  filters: {
    formCreditNum(val) {
      if(!val) return
      
    },
    formDecrypt(val) {
      if(!val) return
      const decryVal = Decrypt(val)
      const newVal = decryVal.substring(0, 4) + ' **** **** ' + decryVal.substring(decryVal.length-4)
      return newVal 
    }
  }
}
</script>

<style lang="scss" scoped>
.gmail-con{
  display: flex;
  align-items: center;
  height: 68px;
  border-top: 1px solid #F1F4F6;
  justify-content: space-between;
  >div{
    display: flex;
    align-items: center;
  }
  >span{
    display: inline-block;
    cursor: pointer;
    width: 58px;
    height: 28px;
    font-weight: normal;
    font-size: 12px;
    line-height: 28px;
    text-align: center;
    color: #636D86;
    &:hover{
      background: #F4F4F6;
      border-radius: 50px;
    }
  }
  img{
    width: 32px;
    height: 18px;
    margin-left: 17px;
  }
  h4{
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #222C43;
    margin-left: 12px;
  }
}
.email-con{
  h4{
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #222C43;
  }
}
.validity-con{
  display: flex;
  .right{
    margin-left: 24px;
  }
  >div{
    flex: 1;
  }
  .right-con{
    display: flex;
    align-items: center;
    >i{
      margin-left: 6px;
    }
  }
  h4{
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #222C43;
  }
}
.form-item-con{
  margin-top: 8px;
}
.card-con{
  display: flex;
  justify-content: space-between;
  align-items: center;
  h4{
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #222C43;
  }
  img{
    width: 32px;
    height: 18px;
    margin-left: 2px;
  }
}
.img-con{
  img:nth-of-type(1){
    margin-left: 0;
  }
}
.credit-wrap{
  padding: 0 18px;
}
.credit-add{
  line-height: 68px;
  border-top: 1px solid #F1F4F6;
  i{
    font-size: 10px;
    color: $color-orange;
  }
  span{
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-orange;
  }
  >div{
    width: 120px;
    cursor: pointer;
  }
}
.switch-add{
  line-height: 68px;
  border-top: 1px solid #F1F4F6;
  i{
    font-size: 10px;
    color: #222C43;
  }
  span{
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #222C43;
  }
  >div{
    width: 120px;
    cursor: pointer;
  }
}
@media screen  and (min-width: 600px){
  .credit-wrap {
    border-bottom: 1px solid #F1F4F6;
  }
}
.add-credit-dialog-wrap{
  .el-button{
    width: 100%;
    background: #FA006E;
    border-radius: 50px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
} 
</style>
<style lang="scss">
.credit-wrap{
  .el-radio__label{
    display: none;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-radio__inner{
    width: 20px;
    height: 20px;
  }
}
.add-credit-dialog-wrap{
  .el-dialog__body{
    border-top: 1px solid #E8EAEE;
  }
  .el-input{
    background: #F9F9F9;
    border: 1px solid #E8EAEE;
    border-radius: 8px;
  }
}
</style>
